import React, { useLayoutEffect } from "react";
import { ManhattanLifeLogo, WholeLifeBrochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBWholeLifeImage from "../../../../../assets/VEBPlanImages/VEBWholeLifeImage.avif";
import "./wholeLife.scss";

const WholeLife: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="whole-life-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Whole Life</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={ManhattanLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							The loss of a loved one is not something that anyone likes to think about. But the fact of
							the matter is—it can happen to all of us. Ensuring that both you and your family are
							financially protected in the event of such a loss is essential.
						</span>

						<h3>Whole Life Insurance Features</h3>
						<ul>
							<li>Builds cash value over time at a guaranteed rate. </li>
							<li>Premiums never increase.</li>
							<li> No health questions, height or weight.</li>
							<li>
								Guaranteed issue up to $100,000 for employees, $50,000 for spouse and $50,000 for
								dependent child(ren) / grandchild(ren).{" "}
							</li>
							<li>Terminal illness benefit automatically included.</li>
						</ul>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBWholeLifeImage} alt="VEB Whole life image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={WholeLifeBrochure} />
			</div>
		</div>
	);
};

export default WholeLife;
